module.exports = __webpack_public_path__ + "img/dark_logo.4ccaf04a.png";